import { defineComponent as _defineComponent } from 'vue'
import { Subscription } from '@/@types/billing';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrentPlan',
  props: {
    subscription: null
  },
  setup(__props: any) {

const props = __props as { subscription: Subscription }



const item = computed(() => props.subscription.items[0]);
const planName = computed(() => item.value.price.name);
const planCost = computed(
  () => `$ ${+item.value.price.unitPrice.amount / 100},00/user/${item.value.price.billingCycle.interval}`
);
const users = computed(() => item.value.quantity);
const cycle = computed(() => item.value.price.billingCycle.interval);
const totalCost = computed(
  () => `$ ${(+item.value.price.unitPrice.amount / 100) * users.value},00/${item.value.price.billingCycle.interval}`
);

return { __sfc: true,props, item, planName, planCost, users, cycle, totalCost }
}

})